import { IndividualListDto } from '@common/dto/individual/list-dto';
import { executeUI } from '@common/utils/ui-bridge';

export const createBatchLetters = (globalIds: Array<IndividualListDto['id']>) => {
  executeUI('LETTERS', 'batchLetters', globalIds.join(','));
};